import { connect } from 'react-redux';
import { compose } from 'redux';
import { clearSubmitErrors, initialize, reduxForm, SubmissionError } from 'redux-form';

import request from 'common/Api';
import { FORMS } from 'common/Constants';
import { receiveAzure, signInAs } from 'common/SearchStore/SearchActions';
import { getAzureData, getBooking } from 'common/SearchStore/SearchSelectors';
import { updateSelectedBookingPassenger } from 'common/UserStore/UserActions';
import { getBookingId, getCruiseName, getPassengerNumber } from 'common/UserStore/UserSelectors';
import { base64Encode } from 'utils/strings';
import SignInAs from './SignInAs';

const mapStateToProps = (state) => {
  const { email = '', firstName = '', lastName = '' } = getAzureData(state);

  return {
    initialValues: {
      email: '',
      firstName,
      lastName,
    },
    passengerNumber: getPassengerNumber(state),
    booking: getBooking(state),
    email,
    cruiseName: getCruiseName(state),
    bookingId: getBookingId(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onClose: () => {
    dispatch(initialize(FORMS.SIGN_IN_AS));
    dispatch(receiveAzure({}));
    dispatch(updateSelectedBookingPassenger({ passengerNumber: null, cruiseName: null, bookingId: null }));
  },
});

const onSubmit = ({ ...values }, dispatch, { bookingId }) =>
  new Promise((_resolve, reject) => {
    dispatch(clearSubmitErrors(FORMS.SIGN_IN_AS));
    const email = base64Encode(values.email.toLowerCase());
    return dispatch(request({ method: 'GET', url: `/csp/user/${email}` }))
      .then((authUserData) => {
        const { authData, userToken } = authUserData || {};
        const {
          customUserType: userType,
          emailAddress,
          givenName: firstName,
          id,
          surname: lastName,
          userPrincipalName,
        } = authData || {};
        const userData = { firstName, lastName, email: emailAddress, userType, id, userPrincipalName };
        if (!userData?.email) {
          const formError = 'No matching MVJ Accounts found. Please advise the guest to create a new MVJ account.';
          return reject(new SubmissionError({ _error: formError }));
        }
        dispatch(
          receiveAzure({
            ...userData,
            email: values.email,
            userToken,
          }),
        );
        return dispatch(
          signInAs({
            bookingId,
            email: values.email,
            userToken,
          }),
        );
      })
      .catch(({ response }) => {
        let formError = 'No matching MVJ Accounts found. Please advise the guest to create a new MVJ account.';
        if (response.status === 503) {
          formError =
            'My Viking Journey is currently down for maintenance and will be back soon.' +
            '<br /> Please try again later.';
        }
        return reject(new SubmissionError({ _error: formError }));
      });
  });

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: FORMS.SIGN_IN_AS,
    enableReinitialize: true,
    onSubmit,
  }),
)(SignInAs);

export default enhance;
